'use client';

import { useIsUpTo } from 'hooks';
import { CtaContainer, type CtaContainerProps } from 'ui/ui-patterns/components/cta-container';

type CtaContainerAboutProps = Readonly<CtaContainerProps>;

export const CtaContainerAbout = (props: CtaContainerAboutProps) => {
  const isUpToTablet = useIsUpTo('md');
  return <CtaContainer {...props} size={isUpToTablet ? 'sm' : 'md'} />;
};
